<pxw-tag *transloco="let t" size="xs" [uppercase]="false">
  <pxw-icon icon="arrow-up" size="xxs" />
  {{ t(templateKey(), templateParams()) }}
</pxw-tag>
